import user from './user';
import role from './role';
import permission from './permission';
export default {
    namespaced: true,
    state: {
       
    },
    mutations: {},
    actions: {},
    modules: {
        user,
        role,
        permission
    }
}